// extracted by mini-css-extract-plugin
export default {"store":"OrderCreationConfirmationModal__store___POnPk"};